import React from 'react';
import { Icon } from '~/components';

function Spinner() {
  return <Icon icon="spinner" spin spaceRight />;
}
export default Spinner;
